import React from "react";

const EmbedCode = ({ code: _code }) => {
  if (_code) {
    // standardize urls
    const code = _code
      .replace(`<script async src="//www.instagram.com/embed.js"></script>`, "")
      .replace(
        `<script async="" src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>`,
        ""
      )
      .replace("https://", "//")
      .replace("http://", "//")
      .replace("//", "https://");
    if (typeof window !== "undefined") {
      return (
        <div className="embedCode">
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: code }} />
        </div>
      );
    }
  }
  return <div />;
};

export default EmbedCode;
